import React from 'react';
import { useLocation } from 'react-router-dom';
import { SEO } from './SEO';
import seoRoutes from '@/seo/seoRoutes.json';

// Schemas JSON-LD par route : source unique partagée avec scripts/prerenderSeo.mjs, qui les
// écrit aussi dans le HTML statique servi aux robots sans JavaScript.
// ⚠️ Pas d'aggregateRating ici : des notes codées en dur, sans avis visibles sur la page,
// enfreignent les règles de Google sur les données structurées (retiré le 2026-10-05).
// Les vrais avis sont portés par /temoignages via son propre <SEO>.
const SCHEMAS = seoRoutes.schemas as Record<string, Record<string, unknown>>;

const ROUTE_SCHEMAS: Record<string, Record<string, unknown>> = Object.fromEntries(
    seoRoutes.routes
        .filter((r): r is typeof r & { schema: string } => 'schema' in r && typeof r.schema === 'string')
        .map(r => [r.path, SCHEMAS[r.schema]])
);

/**
 * SEOManager
 * Fournit UNIQUEMENT le JSON-LD (données structurées) associé à une route.
 *
 * Les <title>/<meta>/<link canonical> sont rendus par CHAQUE page via son propre <SEO> :
 * React 19 hoiste ces balises mais ne les déduplique pas, donc une seule source par route.
 * Ne pas réintroduire ici de titre ou de description — cela créerait un second <title>
 * concurrent sur les pages qui gèrent déjà le leur.
 *
 * Les schemas de src/seo/seoRoutes.json sont statiques ; ceux qui dépendent de données chargées
 * (avis de /temoignages, offre de /sentinel) sont passés par la page à son <SEO>.
 */
export const SEOManager: React.FC = () => {
    const location = useLocation();
    const schema = ROUTE_SCHEMAS[location.pathname.toLowerCase().replace(/(.)\/$/, '$1')];

    if (!schema) return null;
    return <SEO structuredData={schema} />;
};
